/* Karte auf dem Server speichern: als neue Karte (Name) oder, bei verbundener Karte, sofort („Jetzt speichern“).
 * Verbundene Karten werden zusätzlich automatisch gespeichert. */
import { useState } from 'react';
import type { CloudLink } from '../net/cloud.ts';
import { isReadOnly } from '../net/cloud.ts';
import { Dialog, DialogBody, DialogFoot } from './dialog.tsx';
import { useStore, useT } from './hooks.ts';

export interface SaveHost {
  /** Dateiname der aktuellen Karte (Vorschlag für den Namen) */
  fileName(): string;
  setFileName(name: string): void;
  isBsp(): boolean;
}

export function SaveDialog(props: { cloud: CloudLink; host: SaveHost; onClose: () => void }) {
  const t = useT();
  const { cloud, host } = props;
  const link = useStore(cloud).link;
  const [name, setName] = useState(host.fileName());
  const [msg, setMsg] = useState<string | null>(null);
  const writable = !!link && !isReadOnly(link);

  const guard = async (fn: () => Promise<void>) => {
    try { await fn(); } catch (e) { const err = e as { status?: number; data?: unknown; message: string }; setMsg(err.status === 409 && !err.data ? t('cloud.name_taken') : t('cloud.save_failed', { msg: err.message })); }
  };
  const saveNew = () => guard(async () => {
    const n = name.trim(); if (!n) return;
    const m = await cloud.createFromCurrent(n);
    host.setFileName(m.name); props.onClose();
  });
  const saveNow = () => guard(async () => { if (await cloud.save()) { const l = cloud.getSnapshot().link; if (l) setMsg(t('cloud.saved', { name: l.name, rev: l.rev })); } });

  const nameRow = (
    <div className="row">
      <input type="text" className="inp" style={{ flex: 1 }} maxLength={120} aria-label={t('cloud.name')} placeholder={t('cloud.name')} value={name}
        onChange={(e) => setName(e.target.value)} onKeyDown={(e) => { if (e.key === 'Enter') void saveNew(); }} />
      <button className={'btn' + (writable ? '' : ' primary')} onClick={() => void saveNew()}>{t(writable ? 'cloud.save_new' : 'cloud.save_server')}</button>
    </div>
  );
  return (
    <Dialog title={t('save.title')} onClose={props.onClose}>
      <DialogBody>
        {host.isBsp() ? <div className="warnbox">{t('cloud.no_bsp')}</div> : (
          <>
            {link && <p className="small">{t(writable ? 'save.linked' : 'save.linked_ro', { name: link.name, rev: link.rev })}</p>}
            {writable && <div className="row"><button className="btn primary" onClick={() => void saveNow()}>{t('cloud.save_now')}</button></div>}
            {writable ? <fieldset><legend>{t('cloud.save_new')}</legend>{nameRow}</fieldset> : nameRow}
          </>
        )}
        {msg && <p className="small" role="status">{msg}</p>}
      </DialogBody>
      <DialogFoot><button className="btn" onClick={props.onClose}>{t('ui.close')}</button></DialogFoot>
    </Dialog>
  );
}
